/** Share of a card that must be on screen before it can take over. */
export const STRIP_FULLY_VISIBLE = 0.97;

type Span = { left: number; right: number };

/**
 * Which card of a sideways media strip owns playback (its video, or the
 * post's song over a photo). The incumbent keeps it while it is still fully
 * on screen; otherwise the leftmost FULLY visible card takes over. While no
 * card is fully visible — mid-swipe between two — nothing changes, so a card
 * that is only peeking in never starts.
 */
export function pickActiveStripCard(
  cards: readonly Span[],
  viewport: Span,
  current: number,
): number {
  const fullyVisible: number[] = [];
  cards.forEach((card, index) => {
    const width = Math.max(1, card.right - card.left);
    const shown =
      Math.max(
        0,
        Math.min(card.right, viewport.right) -
          Math.max(card.left, viewport.left),
      ) / width;
    if (shown >= STRIP_FULLY_VISIBLE) fullyVisible.push(index);
  });
  if (fullyVisible.includes(current)) return current;
  return fullyVisible[0] ?? current;
}
